// components/ArticleList.tsx
import React from 'react';
import { Card } from '@mui/material';
import { TFunction } from 'next-i18next';
import Texto from '../../Texto';
import { textosPeque } from '@/constants/Dimens';
import { PuntuarUsuarioLibroObj } from '@/objects/Articles';
import Boton from '../../Boton';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { mostrarAlerta } from '../../Dialog';
import PuntuarUsuario from '@/components/widgets/PuntuarUsuario';
import { dateToTextTForm, obtenerHoraTForm } from '@/util/MagicDate';
import { useNotificationContext } from '@/context/NotificationContext';
import CardUser from '@/components/widgets/libro/CardUser';

interface Props {
  t: TFunction;
  puntuacionObj: PuntuarUsuarioLibroObj;
  onCargar: () => void;
}

const RowPuntuarUsuarioLibro: React.FC<Props> = ({ t, puntuacionObj, onCargar }) => {

  const { userData } = useNotificationContext();

  const [id_otro_usuario, setIdOtroUsuario] = React.useState<number>(0);

  React.useEffect(() => {
    if (userData?.id_user == puntuacionObj.id_user_vende) {
      setIdOtroUsuario(puntuacionObj.id_user_compra);
    } else {
      setIdOtroUsuario(puntuacionObj.id_user_vende);
    }
  }, [puntuacionObj, userData]);

  function puntuarUsuario() {
    mostrarAlerta({
      title: t('menu:secciones.puntuaciones.pulsa_para_puntuar'),
      content: <PuntuarUsuario t={t} puntuacionObj={puntuacionObj} />,
      acceptText: t('common:opciones.cancelar'),
      onAccept: () => {

      }
    });
  }

  return (
    <Card
      style={{
        cursor: "pointer", display: 'flex', flexDirection: 'row',
        alignItems: 'center', justifyContent: 'space-between',
        width:
          window.innerWidth < 500 ? "94%" : "500px",
        padding: "20px",
        marginTop: "20px",
      }}>
      <article style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: "100%" }}>
        <section style={{ display: 'flex', flexDirection: 'column', marginLeft: "20px", width: "100%" }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: "20px", width: "100%" }}>
            <CardUser id_usuario={id_otro_usuario} />
          </div>

          <Texto>{t("menu:secciones.puntuaciones.puntua_la_compra")}</Texto>
          <div>
            <Texto fontSize={textosPeque}>{puntuacionObj.Nombre}</Texto>
          </div>

          <Texto fontSize={textosPeque}>{puntuacionObj.fecha}</Texto>
          <div style={{ display: 'flex', flexDirection: 'column', alignContent: "center", alignItems: "center", width: "100%", marginTop: "10px" }}>
            <Boton fullWidth startIcon={<ReviewsIcon />} texto={t("menu:secciones.puntuaciones.pulsa_para_puntuar")} onClick={puntuarUsuario} />
          </div>
        </section>
      </article>
    </Card>
  );
};

export default RowPuntuarUsuarioLibro;
